import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ChartLineUp, ShieldCheck } from "@phosphor-icons/react";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password: pw });
      setDone(true);
      toast.success("Password set — you can now sign in");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) { toast.error(err.response?.data?.detail || "Could not set password"); }
    finally { setBusy(false); }
  };

  const cls = "w-full border border-black/20 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#faf9f6] p-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <ChartLineUp size={26} weight="fill" color="#002FA7" />
          <span className="font-head font-black text-lg">VIRTUALEENA</span>
        </div>
        <div className="card p-7">
          {!token ? (
            <p data-testid="sp-invalid" className="text-sm text-[#FF3B30] text-center">Invalid link — no token provided.</p>
          ) : done ? (
            <div className="text-center">
              <ShieldCheck size={34} weight="fill" className="mx-auto mb-2 text-[#00A86B]" />
              <p className="font-head font-bold">Password set!</p>
              <p className="text-sm text-[#888]">Redirecting to sign in…</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <p className="font-head font-black text-xl mb-1">Set your password</p>
              <p className="text-sm text-[#888] mb-2">Create a password to access your Virtualeena portal.</p>
              <input data-testid="sp-password" type="password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className={cls} />
              <input data-testid="sp-confirm" type="password" placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={cls} />
              <button data-testid="sp-submit" disabled={busy} className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white py-2.5 rounded-sm transition-colors disabled:opacity-60">
                {busy ? "Saving…" : "Set Password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
